export enum RoleType {
  Learner = "Learner",
  Grader = "Grader",
  Instructor = "Instructor",
  Administrator = "Administrator",
}
